import * as actionType from "./ActionTypes";

export default function UserAccessDataReducer(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.LOAD_USER_ACCESS:
      return (state = payload);
    default: 
      return  state;
  }
}
